// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.layout-footer[data-v-6bdb0e5a] {\n  width: 100%;\n  padding: 12px 0;\n  text-align: center;\n  font-size: 13px;\n  color: var(--prev-color-text-secondary);\n}\n", ""]);
// Exports
module.exports = exports;
